import React from 'react';
import { useForm, SubmitHandler, Controller } from 'react-hook-form';
import Input from '../../../../components/elements/form/input';
import Teaxtarea from '../../../../components/elements/form/textarea';
import SelectBox from '../../../../components/elements/form/selectBox';
import { DropdownOptionType, Option } from '../../../../_config/types';
import Datepicker from '../../../../components/elements/form/datepicker';
import  Button  from '../../../../components/elements/button';
import { AgGridReact } from 'ag-grid-react';
import Icon from '../../../../components/icons';

type FormValues = {
    assetName: string;
    drop: DropdownOptionType;
    assetType: string;
    purchaseDate: Date;
};

const CreatePurchaseOrder: React.FC = () => {
    
    const {control, register, handleSubmit, formState: { errors } } = useForm<FormValues>();
        
        const onSubmit: SubmitHandler<FormValues> = data => {
            console.log(data);
        };
        
        const columnDefs = [
            { headerName: 'Item', field: 'item', headerClass: 'bg-[#f0f0f0]'},
            { headerName: 'Cost', field: 'cost', headerClass: 'bg-[#f0f0f0]'},
            { headerName: 'Quantity', field: 'qty', headerClass: 'bg-[#f0f0f0]'},
            { headerName: 'Total', field: 'total', headerClass: 'bg-[#f0f0f0]'},
          ];
        
          // Define row data
          const rowData: any[] = [
            { 'item': 'M8 28mm Hex Bolt', 'cost': 'M8 28mm Hex Bolt', 'qty': 'VP 001', 'total': '50,00'},
            { 'item': 'M8 28mm Hex Bolt', 'cost': 'M8 28mm Hex Bolt', 'qty': 'VP 001', 'total': '50,00'},
            { 'item': 'M8 28mm Hex Bolt', 'cost': 'M8 28mm Hex Bolt', 'qty': 'VP 001', 'total': '50,00'},
            { 'item': 'M8 28mm Hex Bolt', 'cost': 'M8 28mm Hex Bolt', 'qty': 'VP 001', 'total': '50,00'},
            { 'item': 'M8 28mm Hex Bolt', 'cost': 'M8 28mm Hex Bolt', 'qty': 'VP 001', 'total': '50,00'},
            { 'item': 'M8 28mm Hex Bolt', 'cost': 'M8 28mm Hex Bolt', 'qty': 'VP 001', 'total': '50,00'},
            { 'item': 'M8 28mm Hex Bolt', 'cost': 'M8 28mm Hex Bolt', 'qty': 'VP 001', 'total': '50,00'},
            { 'item': 'M8 28mm Hex Bolt', 'cost': 'M8 28mm Hex Bolt', 'qty': 'VP 001', 'total': '50,00'},
            { 'item': 'M8 28mm Hex Bolt', 'cost': 'M8 28mm Hex Bolt', 'qty': 'VP 001', 'total': '50,00'},

          ];

    return (
         <form onSubmit={handleSubmit(onSubmit)}>
            <div className='pt-4'>
            <h4 className='font-semibold text-[0.938rem] py-4 uppercase'>Basic Information</h4>
                <Controller
                        name='assetName'
                        control={control}
                        render={({ field :{value,onChange} }) => (
                            <Input 
                            label='PO Number'
                            type='text'
                            value={value}
                            onChange={onChange}
                            placeholder='Write PO Number'
                            />
                        )}
                    />
                   <div className='grid grid-cols-2 gap-2'>
                    <Controller
                                name='drop'
                                control={control}
                                render={({ field :{value,onChange} }) => (
                                    <SelectBox 
                                    label='Vendor'
                                    value={value}
                                    onChange={onChange}
                                    required
                                    placeholder='A2technology'
                                    options={[]}
                                    className='mb-0'
                                    />
                                )}
                            />
                            <Controller
                                name='purchaseDate'
                                control={control}
                                render={({ field :{value,onChange} }) => (
                                    <Datepicker 
                                    label='Due Date'
                                    value={value}
                                    onChange={onChange}
                                    />
                                )}
                            />
                   </div>
                
                        <Controller
                            name='drop'
                            control={control}
                            render={({ field :{value,onChange} }) => (
                                <SelectBox 
                                label='PO Type'
                                value={value}
                                onChange={onChange}
                                required
                                placeholder='Write PO Type'
                                options={[]}
                                className='mb-0'
                                />
                            )}
                        />
                        
                <div className="flex justify-between items-center">
                    <h4 className='font-semibold text-[0.938rem] py-4 uppercase'>Line items</h4> 
                    <span className='flex gap-5'>
                        <button className='text-primary'>Add Purchase Request</button>
                        <button className='text-primary'>Add parts</button>
                     </span>
                </div>
              
                <div className="ag-theme-alpine h-1/2">
                    <AgGridReact
                        columnDefs={columnDefs} // Pass columnDefs
                        rowData={rowData} // Pass rowData
                        pagination={false}
                        domLayout="autoHeight"
                    />
                </div>
                <Controller
                            name='drop'
                            control={control}
                            render={({ field :{value,onChange} }) => (
                                <SelectBox 
                                label='File Name'
                                value={value}
                                onChange={onChange}
                                required
                                placeholder='Upload'
                                options={[]}
                                className='mb-0'
                                />
                            )}
                        />
                    <h4 className='font-semibold text-[0.938rem] py-4 uppercase'>Receiving Store</h4> 
                    <Controller
                            name='drop'
                            control={control}
                            render={({ field :{value,onChange} }) => (
                                <SelectBox 
                                label='Select Facilities'
                                value={value}
                                onChange={onChange}
                                required
                                placeholder='Werehouse 1'
                                options={[]}
                                className='mb-0'
                                />
                            )}
                        />
                <Controller
                    name='assetName'
                    control={control}
                    render={({ field :{value,onChange} }) => (
                        <Input 
                        label='Address'
                        type='text'
                        value={value}
                        onChange={onChange}
                        placeholder='2715 Ash Dr. San Jose, South Dakota 83475'
                         />
                    )}
                />
                 
                 <Controller
                    name='assetName'
                    control={control}
                    render={({ field :{value,onChange} }) => (
                        <Input 
                        label='City'
                        type='text'
                        value={value}
                        onChange={onChange}
                        placeholder='City'
                         />
                    )}
                />
                <div className='grid grid-cols-2 gap-2'>
                    <Controller
                        name='assetName'
                        control={control}
                        render={({ field :{value,onChange} }) => (
                            <Input 
                            label='State'
                            type='text'
                            value={value}
                            onChange={onChange}
                            placeholder='State'
                            />
                        )}
                    />
                    <Controller
                    name='assetName'
                    control={control}
                    render={({ field :{value,onChange} }) => (
                        <Input 
                        label='Zip Code'
                        type='text'
                        value={value}
                        onChange={onChange}
                        placeholder='Zip'
                         />
                    )}
                   />
                </div>
                <Controller
                    name='assetName'
                    control={control}
                    render={({ field :{value,onChange} }) => (
                        <Input 
                        label='Phone No'
                        type='text'
                        value={value}
                        onChange={onChange}
                        placeholder='Phone No'
                         />
                    )}
                   />
                <Controller
                    name='assetName'
                    control={control}
                    render={({ field :{value,onChange} }) => (
                        <Teaxtarea 
                        label='Notes'
                        value={value}
                        onChange={onChange}
                        required
                        placeholder='Notes'
                         />
                    )}
                />
                <hr className='border-gray-900 my-6' />
            </div>
          <div className='flex justify-end gap-2'>
                <Button working={false}>Save</Button>
                <Button theme='secondary' working={false}>Cancel</Button>
            </div>  

            <input id="assetName" {...register('assetName', { required: true })} />
                {errors.assetName && <span>This field is required</span>}

            <div>
                <label htmlFor="assetType">Asset Type</label>
                <input id="assetType" {...register('assetType', { required: true })} />
                {errors.assetType && <span>This field is required</span>}
            </div>

            <div>
                <label htmlFor="purchaseDate">Purchase Date</label>
                <input id="purchaseDate" type="date" {...register('purchaseDate', { required: true })} />
                {errors.purchaseDate && <span>This field is required</span>}
            </div>

            <button type="submit">Create Asset</button>
        </form>
    );
};


export default CreatePurchaseOrder;